import { isServiceSlug, serviceLabel, serviceOptions } from '@4each/common';
import type { SectionConfig } from '../lib/types';

export const referenceSection: SectionConfig = {
  id: 'content.ref', entity: 'reference', title: 'References',
  softDelete: true, draggable: true,
  defaultSort: { column: 'sort', direction: 'asc' },
  columns: [
    { key: 'title', title: 'Client', sortable: true },
    { key: 'image', title: 'Logo', type: 'image' },
    {
      key: 'services', title: 'Services',
      render: (value) => (Array.isArray(value) ? value.filter(isServiceSlug).map(serviceLabel).join(', ') || '—' : '—'),
    },
    { key: 'enabled', title: 'Enabled', type: 'boolean' },
  ],
  formFields: [
    { key: 'title', title: 'Client', type: 'text', required: true },
    { key: 'image', title: 'Logo', type: 'image' },
    { key: 'link', title: 'Client website', type: 'text' },
    { key: 'headline', title: 'Headline (shown on the site with a description)', type: 'text' },
    { key: 'description', title: 'Description', type: 'textarea' },
    { key: 'photo', title: 'Photo', type: 'image' },
    { key: 'metrics', title: 'Metrics', type: 'pairs', maxItems: 4 },
    { key: 'services', title: 'Services', type: 'select', multiple: true, options: serviceOptions },
    { key: 'enabled', title: 'Enabled', type: 'boolean' },
  ],
};

export const partnerSection: SectionConfig = {
  id: 'content.par', entity: 'partner', title: 'Partners',
  softDelete: true, draggable: true,
  defaultSort: { column: 'sort', direction: 'asc' },
  columns: [
    { key: 'title', title: 'Title', sortable: true },
    { key: 'image', title: 'Image', type: 'image' },
    { key: 'enabled', title: 'Enabled', type: 'boolean' },
  ],
  formFields: [
    { key: 'title', title: 'Title', type: 'text', required: true },
    { key: 'image', title: 'Image', type: 'image' },
    { key: 'url', title: 'URL', type: 'text' },
    { key: 'enabled', title: 'Enabled', type: 'boolean' },
  ],
};

export const teamSection: SectionConfig = {
  id: 'content.tea', entity: 'employee', title: 'Team',
  softDelete: true, draggable: true,
  defaultSort: { column: 'sort', direction: 'asc' },
  columns: [
    { key: 'name', title: 'Name', sortable: true },
    { key: 'position', title: 'Position' },
    { key: 'image', title: 'Photo', type: 'image' },
    { key: 'enabled', title: 'Enabled', type: 'boolean' },
  ],
  formFields: [
    { key: 'name', title: 'Name', type: 'text', required: true },
    { key: 'position', title: 'Position', type: 'text' },
    { key: 'bio', title: 'Bio', type: 'richtext' },
    { key: 'image', title: 'Photo', type: 'image' },
    { key: 'email', title: 'Email', type: 'text' },
    { key: 'enabled', title: 'Enabled', type: 'boolean' },
  ],
};

export const featureCardSection: SectionConfig = {
  id: 'content.fea', entity: 'featureCard', title: 'Feature Cards',
  softDelete: true, draggable: true,
  defaultSort: { column: 'sort', direction: 'asc' },
  columns: [
    { key: 'title', title: 'Title', sortable: true },
    { key: 'icon', title: 'Icon' },
    { key: 'enabled', title: 'Enabled', type: 'boolean' },
  ],
  formFields: [
    { key: 'title', title: 'Title', type: 'text', required: true },
    { key: 'description', title: 'Description', type: 'richtext' },
    { key: 'icon', title: 'Icon', type: 'text' },
    { key: 'enabled', title: 'Enabled', type: 'boolean' },
  ],
};
